import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import DialogCloseButton from './DialogCloseButton';
import IconLibrary from '../IconLibrary';

function SmsOptInConfirmDialog({ open, value, onConfirm, onCancel }) {
  const { formatMessage } = useLocalization();
  const [optIn, setOptIn] = useState();

  useEffect(() => {
    if (open) {
      setOptIn(Boolean(value));
    }
  }, [open, value]);

  const title = optIn
    ? formatMessage({
        id: 'SMS_OPT_IN_CONFIRMATION',
        defaultMessage: 'SMS Opt-in Confirmation',
      })
    : formatMessage({
        id: 'SMS_OPT_OUT_CONFIRMATION',
        defaultMessage: 'SMS Opt-out Confirmation',
      });

  const message = optIn
    ? formatMessage({
        id: 'SMS_OPT_IN_CONFIRM_MESSAGE',
        defaultMessage:
          'Selecting SMS Opt‑In will turn on SMS messaging for this phone number everywhere it\u2019s used by this Service Provider.',
      })
    : formatMessage({
        id: 'SMS_OPT_OUT_CONFIRM_MESSAGE',
        defaultMessage:
          'Selecting No SMS will turn off SMS messaging for this phone number everywhere it\u2019s used by this Service Provider.',
      });

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.Warning />
        {title}
        <DialogCloseButton onClose={onCancel} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', my: 1 }}>
        <Button variant="contained" onClick={onConfirm}>
          {formatMessage({
            id: 'CONFIRM',
            defaultMessage: 'Confirm',
          })}
        </Button>
        <Button variant="outlined" onClick={onCancel}>
          {formatMessage({
            id: 'CANCEL',
            defaultMessage: 'Cancel',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SmsOptInConfirmDialog;
